<template>
  <div class="about">
    <!-- <h1>Registered pilots</h1> -->
    <div v-if="showme">
      <AdminLogin @login="setLogIn"></AdminLogin>
    </div>
    <div v-if="!showme">
      <v-btn
        color="primary"
        @click="getnotifyenabledstatus"
        :class="`d-flex justify-space-around mb-6`"
        >Get data (refresh) <v-icon right small>fa-user-cog</v-icon></v-btn
      >
      <v-alert type="success" :value="isAlertVisible">{{
        statusResultMsg
      }}</v-alert>
      <v-alert type="error" :value="isWarningAlertVisible">{{
        statusResultMsg
      }}</v-alert>
      <div v-if="tableVisible1">
        <v-card>
          <v-card-title>
            Notifications
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search name"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="notifysubs"
            :search="search"
            dense
            :loading="loading"
            loading-text="Loading... Please wait"
          >
            <template v-slot:item.NotifyEnabled="{ item }">
              <v-radio-group v-model="radioGroup" dense>
                <v-row>
                  <!-- :key="i" -->
                  <v-radio
                    :value="item.MID"
                    @click="radioClicked(item)"
                  ></v-radio>
                  <v-col cols="1">
                    <div v-if="!item.NotifyEnabled">
                      <v-icon small color="red">fa-lock</v-icon>
                    </div>
                    <div v-if="item.NotifyEnabled">
                      <v-icon small color="green">fa-lock-open</v-icon>
                    </div>
                  </v-col>
                  <v-col cols="1">
                    <v-simple-checkbox
                      v-model="item.NotifyEnabled"
                      dense
                      v-ripple
                    ></v-simple-checkbox>
                  </v-col>
                </v-row>
              </v-radio-group>
            </template>

            <template v-slot:item.RegId="{ item }">
              <v-btn small color="primary" @click="submit(item)"
                >Save {{ item.RegId }}</v-btn
              >
            </template>
            <template v-slot:item.Active="{ item }">
              <v-row>
                <v-col cols="1">
                  <div v-if="!item.Active">
                    <v-icon small color="red">fa-lock</v-icon>
                  </div>
                  <div v-if="item.Active">
                    <v-icon small color="green">fa-lock-open</v-icon>
                  </div>
                </v-col>
                <!-- <v-col cols="2">
                  <v-chip small color="green">{{ item.SmsEventNotify }}</v-chip>
                </v-col>
                <v-col cols="2">
                  <v-chip small color="green">{{ item.NumOfSms }}</v-chip>
                </v-col> -->
              </v-row>
            </template>
            <template v-slot:item.SmsEventNotify="{ item }">
              <div v-if="item.SmsEventNotify > 0">
                <v-chip x-small>{{ item.SmsEventNotify }}</v-chip>
              </div>
            </template>
            <template v-slot:item.NumOfSms="{ item }">
              <div v-if="item.NumOfSms > 0">
                <v-chip x-small>{{ item.NumOfSms }}</v-chip>
              </div>
            </template>
            <template v-slot:item.RegId2="{ item }">
              <div v-if="item.RegId2">
                <v-btn small color="primary" rounded>
                  <v-icon
                    small
                    @click="
                      openSmsDialog(
                        item.RegId2,
                        item.SearchName,
                        item.SmsEventNotify,
                        item.MID
                      )
                    "
                    >fa-sms</v-icon
                  >
                  <!-- {{item.RegId}} -->
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
        <template>
          <v-card outlined href>
            <v-container fluid>
              <label>{{ selectedProfileKey }}</label>
              <!-- <v-spacer></v-spacer> -->
              <copybutton :tocopy="selectedProfileKey"></copybutton>
              <div>.</div>
              <a :href="selectedTelMID"> {{ selectedTelMID }} </a>
              <copybutton :tocopy="selectedMID"></copybutton>
              <div>.</div>
              <label>{{ selectedSearchName }}</label>
              <div>.</div>
              <a :href="selectedSmsWithProfileKey">{{selectedSmsWithProfileKey}}</a>
            </v-container>
          </v-card>
        </template>
      </div>
      <v-row justify="center">
        <v-dialog
          v-model="dialogsms"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogsms = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Send SMS</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <div v-if="dialogsms">
            <!-- <DynamicComponentTest v-bind:id="post.id" v-bind:text="post.text" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest> -->
            <SendSingleSms v-bind="smsTo"></SendSingleSms>
          </div>
        </v-dialog>
      </v-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import AdminLogin from "@/components/Admin/AdminLogIn.vue";
import axios from "axios";
import copybutton from "@/components/Copy.vue";

export default {
  name: "AdminNotificationStatus",
  data() {
    return {
      startInput: 0,
      regId: Number,
      isValid: true,
      ac: String,
      pw: String,
      showme: Boolean,
      search: "",
      loading: true,
      headers: [
        { text: "Name", value: "SearchName" },
        { text: "Mobile", value: "MID" },
        { text: "Notify", value: "NotifyEnabled" },
        { text: "", value: "RegId" },
        { text: "Active", value: "Active" },
        { text: "#En", value: "SmsEventNotify" },
        { text: "#Sms", value: "NumOfSms" },
        { text: "", value: "RegId2" },
      ],
      notifysubs: [],
      isAlertVisible: false,
      isWarningAlertVisible: false,
      errors: [],
      statuses: [],
      statusResult: Number,
      statusResultMsg: String,
      cancellink: { to: "/" },
      tableVisible1: false,
      dialogsms: false,
      selectedRegId: Number,
      selectedSearchName: "",
      selectedSmsEventNotify: Number,
      smsText: String,
      smsRules: [(v) => !!v || "Text is required"],
      addProfileLink: false,
      smsTo: {
        regId: 0,
        ac: "",
        selectedRegIdList: "None in list",
        selectedName: "No name",
        selectedMobile: "No number",
        smsText: "No text",
        comment: "No comment",
        // regiId: Number,
        // ac: String,
        // selectedRegIdList: String,
        // selectedName: String,
        // selectedMobile: String,
        // smsText: String,
        // comment: String
      },
      showSmsComponent: false,
      selectedTelMID: "",
      selectedSmsMID: "",
      selectedSmsWithProfileKey: "",
      selectedMID: "",
      radioGroup: 1,
      selectedProfileKey: ""
    };
  },
  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    //this.baseUrl = "localhost:3000/dbapi/"
    this.regId = null;
    this.isValid = false;
    this.ac = null;
    this.pw = null;
    this.showme = true;
    this.smsText =
      "Hei. Notification Service er slått på for deg. Du velger selv hvilke områder/bokser du ønsker varsling på i din profil (My Account). ";
  },
  methods: {
    setLogIn(loginmodel) {
      var obj = JSON.parse(loginmodel);
      this.regId = obj.regId;
      this.ac = obj.ac;
      this.pw = obj.pw;
      this.showme = false;
    },
    openSmsDialog(
      selectedRegId,
      selectedSearchName,
      selectedSmsEventNotify,
      selectedMobile
    ) {
      this.smsTo.regId = this.regId;
      this.smsTo.ac = this.ac;
      this.smsTo.selectedRegIdList = selectedRegId.toString();
      this.smsTo.selectedName = selectedSearchName;
      this.smsTo.selectedMobile = selectedMobile;
      this.smsTo.smsText = this.smsText;
      this.smsTo.comment =
        "Number of event notification subscriptions: " + selectedSmsEventNotify;
      this.dialogsms = true;
      this.showComponet = true;
      console.log("smsTo:", this.smsTo);

      //   this.selectedRegId = selectedRegId;
      //   this.selectedSearchName = selectedSearchName;
      //   this.selectedSmsEventNotify = selectedSmsEventNotify;
      //   this.dialogsms = true;
    },
    setShowComponent(value) {
      this.dialogsms = value;
    },
    //Uses post here
    getnotifyenabledstatus() {
      var regId = this.regId;
      var ac = this.ac;
      var pw = this.pw;
      var toSubmit = JSON.stringify({ ac, pw });
      const uri = this.baseUrl + "getnotifyenabledstatus/" + regId;
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        // .get("http://jsonplaceholder.typicode.com/posts")
        // .get('http://localhost:3000/pilotlist')
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.notifysubs = response.data;
          //console.log(this.notifysubs);
          this.loading = false;
          this.tableVisible1 = true;
          this.isAlertVisible = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    submit(item) {
      console.log("Save item:", item);
      var regId = item.RegId;
      var notifyEnabled = item.NotifyEnabled;
      var adminId = this.regId;
      var ac = this.ac;
      var pw = this.pw;
      var toSubmit = JSON.stringify({
        ac,
        pw,
        regId,
        notifyEnabled,
      });
      const uri = this.baseUrl + "setnotificationonuser/" + adminId;
      //console.log(uri);
      //console.log("toSubmit", toSubmit);
      this.postit(uri, toSubmit);
    },
    postit(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            console.log(response.data);
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    radioClicked(item) {
      // console.log('MID:',mid)
      this.selectedTelMID = "tel:" + item.MID;
      this.selectedSmsMID = "sms:" + item.MID;
      this.selectedSmsWithProfileKey = "sms:" + item.MID + "?&body=" + item.ProfileKey;
      this.selectedMID = item.MID;
      this.selectedProfileKey = item.ProfileKey;
      this.selectedSearchName = item.SearchName;
    },
  },
  components: {
    AdminLogin,
    SendSingleSms: () => import("@/components/Admin/SendSingleSms.vue"), //Denne rendrer ved behov <div v-if..>
     copybutton,
  },
};
</script>